import { Button, CircularProgress, Stack } from '@mui/material'
import { generateRecords as generateRecordsApi } from 'api/reports'
import moment from 'moment'
import { useState } from 'react'
import { DateInterval, DateRangeType } from 'types/date.types'
import { downloadArrayBuffer } from 'utils/common'
import { prepareDateRangeParams } from '../helpers/prepareDateRangeParams'
import { BaseTableRequest } from 'types/table.types'

interface Props {
  rangeType: DateRangeType
  year: string
  month: string
  selectedDate: moment.Moment
  dateInterval: DateInterval
}

export const useGenerateRecords = ({
  rangeType,
  year,
  month,
  selectedDate,
  dateInterval,
}: Props) => {
  const dateParams = prepareDateRangeParams(rangeType, year, month, selectedDate, dateInterval)
  const [tableRequest, setTableRequest] = useState<BaseTableRequest>({})
  const [isLoading, setIsLoading] = useState(false)
  const generateRecords = async () => {
    setIsLoading(true)
    try {
      const response = await generateRecordsApi({
        ...tableRequest,
        params: dateParams,
      })
      const fileName = response.headers['content-disposition']
        ? response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '')
        : 'report.pdf'
      downloadArrayBuffer(response.data, fileName)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const GenerateRecordsButton = (
    <Button variant="contained" color="info" onClick={generateRecords} disabled={isLoading}>
      <Stack direction="row" alignItems="center" gap={1} position="absolute">
        {isLoading && <CircularProgress size={16} />}
      </Stack>
      Generate Report
    </Button>
  )

  return { GenerateRecordsButton, tableRequest, setTableRequest }
}
